// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Components
import { BaseComponent } from './views/theme/base/base.component';
import { ErrorPageComponent } from './views/theme/content/error-page/error-page.component';
// Auth
import { AuthGuard } from './core/auth';
import { RoleGuard } from './core/auth/_guards/role.guard';

const routes: Routes = [
	{
		path: 'auth', loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule)
	},
	{
		path: '',
		component: BaseComponent,
		children: [
			{
				path: 'user-management',
				loadChildren: () => import('./views/pages/user-management/user-management.module').then(m => m.UserManagementModule),
				canActivate: [RoleGuard],
				data: {
					groups: [1,4,5]
				}
			},
			{
				path: 'production',
				loadChildren: () => import('./views/pages/production/production.module').then(m => m.ProductionModule),
				canActivate: [RoleGuard],
				data: {
					groups: [1,2,4,5]
				}
			},
			{
				path: 'reports',
				loadChildren: () => import('./views/pages/reports/reports.module').then(m => m.ReportsModule),
				canActivate: [RoleGuard],
				data: {
					groups: [1,2,4,5]
				}
			},
			{
				path: 'alarms',
				loadChildren: () => import('./views/pages/alarms/alarms.module').then(m => m.AlarmsModule),
				canActivate: [RoleGuard],
				data: {
					groups: [1,2,4,5]
				}
			},
			{
				path: 'plant-configuration',
				loadChildren: () => import('./views/pages/plant-configuration/plant-configuration.module').then(m => m.PlantConfigurationModule),
				canActivate: [RoleGuard],
				data: {
					groups: [1,2,4,5]
				}
			},
			{
				path: 'controlir4-config',
				loadChildren: () => import('./views/pages/controlir4-config/controlir4-config.module').then(m => m.Controlir4ConfigModule),
				canActivate: [RoleGuard],
				data: {
					groups: [4]
				}
			},
			{
				path: 'error/403',
				component: ErrorPageComponent,
				data: {
					type: 'error-v6',
					code: 403,
					title: '403... Access forbidden',
					desc: 'Looks like you don\'t have permission to access for requested page.<br> Please, contact administrator'
				}
			},
			{path: 'error/:type', component: ErrorPageComponent},
			{path: '', redirectTo: 'production', pathMatch: 'full'},
			{path: '**', redirectTo: 'production', pathMatch: 'full'}
		]
	},

	{path: '**', redirectTo: 'error/403', pathMatch: 'full'},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
